<template>
  <v-dialog
    content-class="conversion-popup"
    :value="showPopup"
    transition="dialog-bottom-transition"
    overlay-color="conversion-popup__overlay"
    overlay-opacity="0.7"
    max-width="630"
  >
    <template slot:default="dialog" class="hh">
      <v-row class="conversion-popup__dialog">
        <v-col class="conversion-popup__dialog-image pr-0">
          <v-img xs src="../assets/popup-image.png" />
        </v-col>
        <v-col align-self="center" class="conversion-popup__dialog-content ml-5">
          <p class="conversion-popup__dialog-content-title">
            ACCESS TO EVERYTHING
          </p>
          <p class="conversion-popup__dialog-content-description">
            Upgrade to uncover all pricing information for over +3000 SaaS
            companies
          </p>
          <v-btn class="conversion-popup__dialog-content-button ml-3" to="checkout">
            Upgrade now
          </v-btn>
        </v-col>
        <icon-close
          @click.native="closePopup"
          class="conversion-popup__dialog-close-icon"
        />
      </v-row>
    </template>
  </v-dialog>
</template>

<script>
import IconClose from "./icons/IconClose";
export default {
  components: { IconClose },
  name: "ConversionPopup",
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
  },
  methods: {
    closePopup() {
      this.$emit("update:show", false);
    }
  },
  computed: {
    showPopup() {
      return this.show;
    }
  },
};
</script>

<style>
.conversion-popup__overlay {
  background-color: #030134;
}
.conversion-popup__dialog {
  position: relative;
  background-color: #fff;
  margin: 0;
  border-radius: 12px;
  box-shadow: -1px 16px 44px rgba(0, 0, 0, 0.45);
}
.conversion-popup__dialog-image {
  background-color: #fff5d5;
  border-radius: 12px;
}
.conversion-popup__dialog-content-title {
  font-weight: 600;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: -0.5px;
  margin-bottom: 5px !important;
  color: #ee6f78;
}

.conversion-popup__dialog-content-description {
  font-weight: 500;
  font-size: 20px;
  line-height: 1.5;
  color: #030134;
  margin-bottom: 24px !important;
}

.conversion-popup__dialog-content-button.v-btn::first-letter {
  text-transform: uppercase;
}

.conversion-popup__dialog-content-button.v-btn {
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  color: #030134;
  background-color: #f8d153 !important;
  padding: 8px 18px !important;
  border-radius: 8px;
  box-shadow: none;
  text-transform: none;
}
.conversion-popup__dialog-close-icon {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}

@media (max-width: 530px) {
  .conversion-popup.v-dialog--active {
    margin: 0;
    border-radius: 0;
    height: 100%;
    max-height: 100%;
  }
  .conversion-popup__dialog {
    height: 100%;
    border-radius: 0;
  }

  .conversion-popup__dialog-image .v-responsive {
    width: 320px;
    margin: auto;
  }

  .conversion-popup__dialog-content {
    padding: 32px 46px;
  }
}

@media (max-width: 320px) {
  .conversion-popup__dialog {
    height: 110%;
    border-radius: 0;
  }

  .conversion-popup__dialog-image .v-responsive {
    width: 280px;
    margin: auto;
  }

  .conversion-popup__dialog-content {
    padding: 32px 46px;
  }
}
</style>
